const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");
const ACCESS_TOKEN = process.env.ACCESS_TOKEN || process.env.REACT_APP_ACCESS_TOKEN;
/* NodeJS */
/* Proxy */
// const url = `${process.env.REACT_APP_BASE_PROXY_URL}/properties`

module.exports = {
    getCategories: (puid, uid, expireKey, language) =>
        getBaseUrl().then((url) =>
            axios({
                method: "GET",
                url: `${url}/category?puid=${puid}&uid=${uid}&k=${expireKey}&type=Category&language=${language}`,
                headers: { "Authorization": `Bearer ${ACCESS_TOKEN}` },
            })
        ),
    getCategoryByProduct: (productUid, language) =>
        getBaseUrl().then((url) =>
            axios({
                method: "GET",
                url: `${url}/category?product_uid=${productUid}&language=${language}`
            })
        )
}